import { createAsyncThunk } from "@reduxjs/toolkit";
import { agent, encodeGetParams } from "../../api";
import { apiUrlV1 } from "../../config/config";
import { ResponseEntityList, ResponseProfileList } from "../../entities/piggyGame";
import { ApiQueryParams } from "../../entities/global";

const piggyGameUrl = apiUrlV1 + "/v2/organization/game/piggy-bank";

/**
 * Получение списка игр Piggy Bank
 */
export const getPiggyEntityList = createAsyncThunk(
  "piggy/get-entity-list",
  async (params?: ApiQueryParams): Promise<ResponseEntityList> => {
    try {
      const query = encodeGetParams({ ...params })
      const response = await agent.get(`${piggyGameUrl}/read/list${query}`);
      if (response.ok) {
        const data = (await response.json()) as ResponseEntityList;
        return data;
      }
      if (!response.ok) {
        throw Error("No response");
      }
    } catch (error) {
      throw Error("Request is not found");
    }

    return {
      limit: 250,
      page: 1,
      pages: 1,
      total: 0,
      data: []
    };
  }
);
/**
 * Удаление игры по ID
 * @param {number} id - ID игры для удаления.
 * После удаления игры срабатывает чанк на загрузку списка игр. {@link getPiggyEntityList()}
 */
export const deletePiggyEntity = createAsyncThunk(
  'piggy/delete-entity',
  async (param: { id: number }, thunksApi) => {
    try {
      const response = await agent.delete(`${piggyGameUrl}/delete/${param.id}`)
      if (response.ok) {
        thunksApi.dispatch(getPiggyEntityList());
      }
      if (!response.ok) {
        throw Error("No response");
      }
    } catch (error) {
      throw Error("Request is not found");
    }
  }
)

/**
 * Получение списка профилей игры Piggy Bank
 */
export const getPiggyProfilesList = createAsyncThunk(
  "piggy/get-profile-list",
  async (params?: ApiQueryParams): Promise<ResponseProfileList> => {
    try {
      const query = encodeGetParams({ ...params })
      const response = await agent.get(`${apiUrlV1}/v3/organization/game/profile/read/piggyBank/list${query}`);
      if (response.ok) {
        const data = (await response.json()) as ResponseProfileList;
        return data;
      }
      if (!response.ok) {
        throw Error("No response");
      }
    } catch (error) {
      throw Error("Request is not found");
    }

    return {
      limit: 250,
      page: 1,
      pages: 1,
      total: 0,
      data: []
    };
  }
);

/**
 * Удаление профиля по ID
 * @param {number} id - ID профиля для удаления.
 * После удаления ппрофиля срабатывает чанк на загрузку списка игр. {@link getPiggyEntityList()}
 */
export const deletePiggyProfile = createAsyncThunk(
  'piggy/delete-profile',
  async (param: { id: number }, thunksApi) => {
    try {
      const response = await agent.delete(`${piggyGameUrl}/profile/delete/${param.id}`)
      if (response.ok) {
        thunksApi.dispatch(getPiggyProfilesList());
      }
      if (!response.ok) {
        throw Error("No response");
      }
    } catch (error) {
      throw Error("Request is not found");
    }
  }
)